import { pickLocalized, type Agent, type Task, type Template } from "@agentsaas/protocol";
import { useT } from "../app/i18n";
import { useProject, useTemplates } from "../data/queries";
import { useTasks } from "../data/collab";

/** 进行中的任务优先，其次是已分派但还没开始的 */
const ACTIVE: Task["status"][] = ["working", "input_required", "auth_required"];

export function currentTaskOf(tasks: Task[] | undefined, aid: string): Task | undefined {
  const mine = (tasks ?? []).filter((t) => t.assignee === aid);
  return mine.find((t) => ACTIVE.includes(t.status)) ?? mine.find((t) => t.status === "submitted");
}

/** 团队面板共用：角色名（模板名按当前语言）、模板、当前任务 */
export function useTeamInfo(pid: string) {
  const { locale } = useT();
  const project = useProject(pid);
  const templates = useTemplates(project.data?.tenantId, { enabled: !!project.data });
  const tasks = useTasks(pid);
  const templateOf = (a: Agent): Template | undefined => templates.data?.find((x) => x.id === a.templateId);
  return {
    templateOf,
    roleOf: (a: Agent) => {
      const tpl = templateOf(a);
      return tpl ? pickLocalized(tpl.name, locale) : a.role;
    },
    currentTask: (a: Agent) => currentTaskOf(tasks.data, a.id),
    tenantId: project.data?.tenantId,
  };
}
